import CityPageTemplate from "../city-template/CityPageTemplate";
import { clevelandConfig } from "./data";

export default function ClevelandPage() {
  return <CityPageTemplate config={clevelandConfig} />;
}